import { Box, Typography } from "@mui/material";
import ContactUsForm from "../components/ContactUsForm";



export default () => (
    <Box sx={{
        width: '100%',
        maxWidth: '900px',
        marginLeft: 'auto',
        marginRight: 'auto',
    }}>
        <Box sx={{
            paddingLeft: '35px',
            paddingRight: '35px',

            "@media (max-width: 600px)": {
                paddingLeft: '15px',
                paddingRight: '15px',
            },
            "@media (max-width: 400px)": {
                paddingLeft: '5px',
                paddingRight: '5px',
            }
        }}>
            <Typography sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '36px',
                color: '#3B0E59',
                lineHeight: '80%',

                textAlign: 'center',
                mt: 4,

                '@media (max-width: 600px)': {
                    fontSize: '24px',
                },
                '@media (max-width: 400px)': {
                    fontSize: '20px',
                }
            }}>
                Let's Talk
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '20px',
                color: '#212529',
                marginTop: '20px',

                mb: 4,
                textAlign: 'center',

                '@media (max-width: 600px)': {
                    fontSize: '16px',
                    marginTop: '10px',
                },
            }}>
                Please fill out the form below and we will get back to you as soon as possible.
            </Typography>

            <ContactUsForm />
        </Box>
    </Box>
);